// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"wrapper___36AfR","flex":"flex___3UI-Z","label":"label___Haobn","full":"full___9h0_F"};